import { CursoModel } from './CursoModel'
import { UsuarioModel } from './UsuarioModel'

export interface PagamentoModel {
  id: number
  hashPagamento: string
  dataPagamento: Date | null
  dataVencimento: Date
  referenciaPagamento: string
  provedorPagamento: 'HYPERPAY' | 'EFI' | 'MERCADO_PAGO' | null
  meioPagamento: 'PIX' | 'BOLETO' | 'CARTAO' | null
  valor: number
  permiteDescontoPix?: boolean | null
  cupomId: number | null
  cupom: CupomModel | null
  comboVsoft: boolean | null
}

export class MatriculaModel {
  id: number
  createdAt: string
  matricula: string
  uf: string
  statusDetran: STATUS_MATRICULA
  cpfInstrutor: string
  dataInicioCurso: Date
  dataFimCurso: Date
  dataInicioModuloTeorico: Date
  dataFimModuloTeorico: Date
  dataInicioModuloPratico: string
  dataFimModuloPratico: string
  dataValidadeCurso: Date
  identificacaoCertificado: string
  nota: string
  dataValidacaoFacialInicial: Date
  dataValidacaoFacialFinal: Date
  codTicket?: string
  cursoId: number
  curso: CursoModel

  alunoId: number
  aluno: UsuarioModel
  renach: string

  pagamentoId: number
  pagamento: PagamentoModel

  permiteEmissaoCertificado: boolean
  dataEmissaoCertificado: Date

  parceiroId?: number
  parceiroCursoPraticoId?: string
}

export enum STATUS_MATRICULA {
  AGUARDANDO_MATRICULA = 'AGUARDANDO_MATRICULA',
  MATRICULADO = 'MATRICULADO',
  FINALIZADO = 'FINALIZADO',
  AGUARDANDO_ENVIO = 'AGUARDANDO_ENVIO',
  AGUARDANDO_MATRICULA_MODULO_PRATICO = 'AGUARDANDO_MATRICULA_MODULO_PRATICO',
  AGUARDANDO_CONCLUSAO_MODULO_PRATICO = 'AGUARDANDO_CONCLUSAO_MODULO_PRATICO',
}

export type TSTATUS_MATRICULA = keyof typeof STATUS_MATRICULA

export type MEIO_PAGAMENTO = null | 'BOLETO' | 'CARTAO_CREDITO' | 'PIX'

export interface IContentPassoAPasso {
  titles: string[]
  imgs: any[]
  contents: string[]
}

export interface IContentComoFunciona {
  paraQuem: string
  objetivo: string
  tempoCurso: string
  tutores: string
}

export interface DadosAlunoModel {
  nome: string
  cpf: string
  renach: string
  dataNascimento: string
  dataPrimeiraHabilitacao?: string
  estado?: string
  municipio?: string
  email: string
  telefone: string
  cnh?: string
  categoriaCnh?: string
  codigoMunicipio?: string
}

export interface CupomModel {
  id: number
  parceiroId: number
  // parceiro: ParceiroModel
  matriculas: MatriculaModel[]
  valorDesconto: number
  percentualDesconto: number
  codigo: string
  dataInicioVigencia: Date
  dataFimVigencia: Date
  valorComissao: number
  percentualComissao: number
  ufs: string[]
  cursos: number[]
}

export interface Estado {
  nome: string
  uf: string
  link: string
  valor: number
  campos: string[]
  passoAPasso?: IContentPassoAPasso
  comoFunciona?: IContentComoFunciona
}

export interface CursoEstado {
  id: number
  curso: string
  estados: Estado[]
}

// Payment-specific type with required fields for payment components
export type PaymentMatricula = Pick<
  MatriculaModel,
  | 'id'
  | 'parceiroId'
  | 'statusDetran'
  | 'curso'
  | 'aluno'
  | 'pagamento'
>
